import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";
import { WhatsApp } from "@mui/icons-material";
import { getAllowedHref } from "src/_modules/AiSupportChat/core/linkPolicy";

/**
 * «تحتاج إلى موظف دعم؟» + a WhatsApp link (plan §3.5). It only opens
 * WhatsApp in a new tab; nothing else happens (non-negotiable #1). The URL
 * comes from `/eligibility` and still goes through the answer link policy,
 * like escalation links; without an allowed URL the footer isn't rendered.
 *
 * @param {{ whatsappUrl?: string }} props
 */
export default function SupportFooter({ whatsappUrl }) {
  const { t } = useTranslation("aiSupport");
  const href = getAllowedHref(whatsappUrl);
  if (!href) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        columnGap: 1,
        px: 2,
        py: 1,
        borderTop: 1,
        borderColor: "divider",
        flexShrink: 0,
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {t("footer.needHuman")}
      </Typography>
      <Button
        component="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        size="small"
        color="success"
        startIcon={<WhatsApp />}
        sx={{ textTransform: "none" }}
      >
        {t("footer.whatsapp")}
      </Button>
    </Box>
  );
}
